// src/contentFilter.js
// Blocks inappropriate language in real time, as it's typed

const BLOCKED_TERMS = [
  "fuck", "shit", "bitch", "asshole", "bastard", "cunt", "dick", "piss",
  "cock", "whore", "slut", "retard", "faggot", "nigger", "nigga", "spic",
  "chink", "kike", "wetback", "tranny", "rape", "molest",
];

function buildRegex() {
  const escaped = BLOCKED_TERMS.map(w => w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  return new RegExp(`\\b(${escaped.join("|")})\\b`, "gi");
}

const FILTER_REGEX = buildRegex();

export function containsBlockedContent(text) {
  if (!text) return false;
  FILTER_REGEX.lastIndex = 0;
  return FILTER_REGEX.test(text);
}

// Strips blocked words out entirely as the user types
export function stripBlockedContent(text) {
  if (!text) return text;
  return text.replace(FILTER_REGEX, "");
}
